import { useMemo } from "react";
import { Modifydetail } from "../../../../../../redux/apiSpecifications/apiCrud";
import { useTranslation } from "react-i18next";

interface IPracticeRateModifiedDescriptionProps {
    modifyDetailsJson: Modifydetail[];
}

const PracticeRateModifiedDescription = ({
    modifyDetailsJson,
}: IPracticeRateModifiedDescriptionProps) => {
    const { t } = useTranslation();

    const rate_amount: string = useMemo(() => {
        const value = modifyDetailsJson.find(
            (_) => _.key === "rate_amount"
        );

        return value?.value ?? "";
    }, [modifyDetailsJson]);

    return (
        <>
            {t("historical-actions-practice-rate-modified-description", {
                rate_amount: rate_amount,
            })}
        </>
    );
};

export default PracticeRateModifiedDescription;
